<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { useClientActionStore } from '@/store/clientActionStore'

  const clientActionsStore = useClientActionStore()

  const orgLogoUrl = ref<string>('')
  const orgDescription = ref<string>('')
  const orgName = ref<string>('')

  const headers = new Headers()
  if (clientActionsStore.getToken) {
    headers.append('X-Access-Token', `${clientActionsStore.getToken}`)
  }

  onMounted(async () => {
    const status = await clientActionsStore.fetchOrganisation()

    if (status == 200) {
      const org = clientActionsStore.getOrganisation
      orgLogoUrl.value = org.logo ? org.logo : ''
      orgDescription.value = org.description
      orgName.value = org.name
    }
  })

  function hasOrgLogo() {
    return orgLogoUrl.value && orgLogoUrl.value !== ''
  }
</script>

<template>
  <div>
    <img
      v-if="!hasOrgLogo()"
      class="h-10 w-24"
      src="https://s3-eu-central-1.ionoscloud.com/jupus/images/logo.svg"
      alt="Jupus Logo"
    />
    <div>
      <template v-if="hasOrgLogo()">
        <img
          class="h-auto max-h-64 w-auto max-w-64 mix-blend-multiply"
          :src="orgLogoUrl"
          alt="Organization Logo"
          data-cy="clientPortalOrganisationCardLogo"
        />
      </template>
      <template v-else>
        <div
          class="text-xl font-semibold text-black"
          :style="{ fontFamily: 'Inter' }"
        >
          {{ orgName }}
        </div>
      </template>
      <div
        v-if="orgDescription"
        class="w-86 mt-2 text-base font-medium text-gray-500"
        style="white-space: pre-wrap; word-wrap: break-word"
        :style="{ fontFamily: 'Inter' }"
        data-cy="clientPortalOrganisationCardDesc"
      >
        {{ orgDescription }}
      </div>
    </div>
    <div
      v-if="hasOrgLogo()"
      class="footer-container"
    >
      <div class="fixed bottom-0 ml-2 flex h-[30px] w-screen items-center justify-start">
        <div class="font-[Inter] text-[15px] font-medium tracking-tight text-black">Powered by</div>
        <img
          class="ml-[9px] h-[30px] w-[72px]"
          src="https://s3-eu-central-1.ionoscloud.com/jupus/images/logo.svg"
          alt="Jupus Logo"
        />
      </div>
    </div>
  </div>
</template>
